import { useCallback, useMemo, useState } from "react";
import {
  getDefaultUserTableFilters,
  isDefaultUserTableFilters,
} from "../utils/teamUsersTable";

export function useUserTableFilters(isVendorContext = false) {
  const defaultFilters = useMemo(
    () => getDefaultUserTableFilters(isVendorContext),
    [isVendorContext]
  );
  const [filters, setFilters] = useState(defaultFilters);

  const handleFilterChange = useCallback((key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  }, []);

  const handleClearFilters = useCallback(() => {
    setFilters(defaultFilters);
  }, [defaultFilters]);

  return {
    filters,
    setFilters,
    defaultFilters,
    handleFilterChange,
    handleClearFilters,
    hasFilterChanges: !isDefaultUserTableFilters(filters, defaultFilters),
  };
}
